import { render, staticRenderFns } from "./Do-apply-review.vue?vue&type=template&id=275f969b&scoped=true&"
import script from "./Do-apply-review.vue?vue&type=script&lang=js&"
export * from "./Do-apply-review.vue?vue&type=script&lang=js&"
import style0 from "./Do-apply-review.vue?vue&type=style&index=0&id=275f969b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275f969b",
  null
  
)

export default component.exports